// Import strich api calls
import { 
    getFulfilmentServicesBy,
    requestFulfilmentCost
 } from "api/APIStrichCalls";

// Import global hooks
import { useToast } from "global/hooks/useToast";



const useOrderDetails = ({token, setServiceCodes, setFulfilmentDetails, setFulfilmentDetailsPopupOpen, setFulfilmentRequestCosts, setRequestFulfilmentPopupOpen}) => {


    // Define toast options
    const { toastError } = useToast();



    // Handle see more when clicking on fulfilment
    const handleGetFulfilmentDetails = (selectedFulfilmentItem) => {

        // Set current fulfilment details
        setFulfilmentDetails(selectedFulfilmentItem);

        // Display a pop up with editable fulfilment details
        setFulfilmentDetailsPopupOpen(true);

    };



    // Handle request fulfilment button
    const handleRequestFulfilment = async (orderID, deliveryCountry) => {
       
        // Get the fulfilment services
        const servicesResponse = await getFulfilmentServicesBy(token, deliveryCountry);

        // If successful
        if (servicesResponse.success) {

            // Store the services from the response
            setServiceCodes(servicesResponse.results);

        } else {

            const errorMsg = `Could not fetch fulfilment services: ${servicesResponse.error_message ? servicesResponse.error_message  : "Please try again later."}`;

            // Toast error
            toastError({title: "Error", message: errorMsg, autoCloseMs: 3000});

            return;

        }

        // Create and format the payload for the call
        const payload = {
            order_id: orderID,
            service_code: servicesResponse.results[0].service_code,
        }

        // Make the call
        const fulfilmentCostResponse = await requestFulfilmentCost(token, payload);
        
        // Check if successful
        if (fulfilmentCostResponse.success) {

            // Update the state
            setFulfilmentRequestCosts(fulfilmentCostResponse.results);

        } else {

            // Set error message
            const errorMsg = `Could not fetch fulfilment costs: ${fulfilmentCostResponse.error_message ? fulfilmentCostResponse.error_message  : "Oops something went wrong."}`;

            // Toast error
            toastError({title: "Error", message: errorMsg, autoCloseMs: 3000});

        }

        // Display a pop up with editable fulfilment details
        setRequestFulfilmentPopupOpen(true);

    };



    return {

        handleRequestFulfilment,
        handleGetFulfilmentDetails,

    }

};

export default useOrderDetails;